import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col, Input, Button, Dropdown, CheckboxSwitch, PhoneInput, inputValidation, showSuccess } from 'components';
import { showApiError } from 'utils';
import { rolesTypesNameSelect } from 'enums';
import { getAllFranchises, getAllOffices, createEmployee, updateEmployee, getAllPartners } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";

var EmployeeDataForm = function EmployeeDataForm(_ref) {
  var data = _ref.data,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      franchises = _useState2[0],
      setFranchises = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      offices = _useState4[0],
      setOffices = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      partners = _useState6[0],
      setPartners = _useState6[1];

  var officesRef = useRef();
  var partnersRef = useRef();
  var franchiseeRef = useRef();
  var franchiseeIdRef = useRef();

  var initialFormData = _objectSpread(_objectSpread({
    phone: '+359-'
  }, data), {}, {
    can_approve: !!(data !== null && data !== void 0 && data.can_approve)
  });

  useEffect(function () {
    fetchAllFranchises();
    fetchAllOffices();
    fetchAllPartners();
  }, []);

  var fetchAllFranchises = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getAllFranchis, _yield$getAllFranchis2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllFranchises();

            case 2:
              _yield$getAllFranchis = _context.sent;
              _yield$getAllFranchis2 = _slicedToArray(_yield$getAllFranchis, 2);
              res = _yield$getAllFranchis2[0];
              err = _yield$getAllFranchis2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setFranchises(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchAllFranchises() {
      return _ref2.apply(this, arguments);
    };
  }();

  var fetchAllOffices = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _yield$getAllOffices, _yield$getAllOffices2, res, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getAllOffices();

            case 2:
              _yield$getAllOffices = _context2.sent;
              _yield$getAllOffices2 = _slicedToArray(_yield$getAllOffices, 2);
              res = _yield$getAllOffices2[0];
              err = _yield$getAllOffices2[1];

              if (!err) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 8:
              setOffices(res);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchAllOffices() {
      return _ref3.apply(this, arguments);
    };
  }();

  var fetchAllPartners = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _yield$getAllPartners, _yield$getAllPartners2, res, err;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getAllPartners();

            case 2:
              _yield$getAllPartners = _context3.sent;
              _yield$getAllPartners2 = _slicedToArray(_yield$getAllPartners, 2);
              res = _yield$getAllPartners2[0];
              err = _yield$getAllPartners2[1];

              if (!err) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return", showApiError(err));

            case 8:
              setPartners(res);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function fetchAllPartners() {
      return _ref4.apply(this, arguments);
    };
  }();

  var filterOffices = function filterOffices(franchiseeId) {
    var _officesRef$current;

    if (franchiseeIdRef.current !== franchiseeId) officesRef === null || officesRef === void 0 ? void 0 : (_officesRef$current = officesRef.current) === null || _officesRef$current === void 0 ? void 0 : _officesRef$current.clear();
    franchiseeIdRef.current = franchiseeId;
    return offices === null || offices === void 0 ? void 0 : offices.filter(function (el) {
      return (el === null || el === void 0 ? void 0 : el.franchisee_id) === franchiseeId;
    });
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref5) {
      var values, method, params, _yield$method, _yield$method2, res, err;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              values = _ref5.values;
              method = data ? updateEmployee : createEmployee;
              params = data ? [data === null || data === void 0 ? void 0 : data.id, _objectSpread(_objectSpread({}, data), values)] : [values];
              _context4.next = 5;
              return method.apply(void 0, params);

            case 5:
              _yield$method = _context4.sent;
              _yield$method2 = _slicedToArray(_yield$method, 2);
              res = _yield$method2[0];
              err = _yield$method2[1];

              if (!err) {
                _context4.next = 11;
                break;
              }

              return _context4.abrupt("return", showApiError(err));

            case 11:
              showSuccess("\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u044F ".concat(data ? 'реадактиран' : 'създаден', " \u0443\u0441\u043F\u0435\u0448\u043D\u043E."));
              _isFunction(onSubmit) && onSubmit(res);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleSubmit(_x) {
      return _ref6.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(Form, {
    onSubmit: handleSubmit,
    values: initialFormData
  }, ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "name",
    label: "\u0418\u043C\u0435",
    required: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "password",
    label: "\u041F\u0430\u0440\u043E\u043B\u0430",
    validate: data ? inputValidation('password') : inputValidation('required', 'password')
  })), ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(PhoneInput, {
    required: true,
    formId: "phone",
    label: "\u041C\u043E\u0431\u0438\u043B\u0435\u043D"
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Input, {
    formId: "email",
    label: "\u0418\u043C\u0435\u0439\u043B",
    validate: inputValidation('required', 'email')
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    required: true,
    formId: "user_role",
    label: "\u0420\u043E\u043B\u044F",
    options: rolesTypesNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    ref: franchiseeRef,
    formId: "franchisee_id",
    label: "\u041A\u0440\u0435\u0434\u0438\u0442\u0435\u043D \u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0438\u043A",
    displayKey: "name",
    uniqueKey: "id",
    options: franchises,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, function (_ref7) {
    var _values$franchisee_id;

    var values = _ref7.values;
    return ___EmotionJSX(Dropdown, {
      ref: officesRef,
      withSearch: true,
      multiSelect: true,
      formId: "offices",
      label: "\u041E\u0444\u0438\u0441\u0438",
      uniqueKey: "id",
      displayKey: "name",
      options: filterOffices((_values$franchisee_id = values === null || values === void 0 ? void 0 : values.franchisee_id) !== null && _values$franchisee_id !== void 0 ? _values$franchisee_id : data === null || data === void 0 ? void 0 : data.franchisee_id)
    });
  }), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    ref: partnersRef,
    withSearch: true,
    multiSelect: true,
    formId: "partners",
    label: "\u041F\u0430\u0440\u0442\u043D\u044C\u043E\u0440\u0438, \u043A\u044A\u043C \u043A\u043E\u0438\u0442\u043E \u0440\u0430\u0431\u043E\u0442\u0438",
    uniqueKey: "id",
    displayKey: "name",
    options: partners
  })), ___EmotionJSX(Col, {
    sm: 12,
    margin: "0 0 2em 0"
  }, ___EmotionJSX(CheckboxSwitch, {
    label: "\u041F\u0440\u0430\u0432\u0430 \u0437\u0430 \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0435",
    formId: "can_approve"
  })), ___EmotionJSX(Col, {
    displayFlex: true,
    md: 12,
    justify: "flex-end"
  }, function (_ref8) {
    var onSubmit = _ref8.onSubmit;
    return ___EmotionJSX(React.Fragment, null, _isFunction(onClose) && ___EmotionJSX(Button, {
      type: "secondary",
      onClick: onClose,
      margin: "0 1em 0 0"
    }, "\u041D\u0430\u0437\u0430\u0434"), ___EmotionJSX(Button, {
      onClick: onSubmit
    }, "\u0417\u0430\u043F\u0430\u0437\u0438"));
  })));
};

EmployeeDataForm.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  data: PropTypes.object
};
export default EmployeeDataForm;